import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

type NoSearchResultsProps = {
  testId?: string;
  className?: string;
};

const NoSearchResults = ({ testId, className = '' }: NoSearchResultsProps) => (
  <div
    data-testid={testId}
    className={`flex h-full min-h-0 w-full flex-col items-center justify-center text-xl text-[#5D5D5D] ${className}`}
  >
    <RMSvgIcon name="NoResult" width="5rem" height="5rem" />
    Result Not Found
  </div>
);

export default NoSearchResults;
